import { RefObject, VideoHTMLAttributes, createRef, memo } from "react";
import { useHlsVideo } from "./hooks";

interface HlsVideoProps
  extends VideoHTMLAttributes<HTMLVideoElement> {
  videoRef?: RefObject<HTMLVideoElement>;
  useHlsEngine?: boolean;
  onMounted?: () => void;
}

export const HlsVideo = memo(({
  videoRef = createRef<HTMLVideoElement>(),
  onMounted,
  src = "",
  autoPlay = false,
  useHlsEngine = false,
  ...restProps
}: HlsVideoProps) => {
  useHlsVideo({ videoRef, autoPlay: !!autoPlay, src, useHlsEngine, onMounted });

  return <video ref={videoRef} src={src} autoPlay={autoPlay} {...restProps} />;
});
